import { render, staticRenderFns } from "./PettyCashDetail.vue?vue&type=template&id=09187d32"
import script from "./PettyCashDetail.vue?vue&type=script&lang=js"
export * from "./PettyCashDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports